module.exports = __webpack_public_path__ + "static/media/LemonEventGuide.57192d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/LemonEventGuide.png
// module id = 456
// module chunks = 0